import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MainButton from "../../components/Elements/MainButton/MainButton";
import emptyImg from "../../assets/icons/cart/cart-gray.png";
import "./Cart.css";

const EmptyCartView = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || "en";

  return (
    <div className="cart-container">
      <section className="empty-cart">
        <img src={emptyImg} alt="" aria-hidden="true" className="empty-cart__img" />
        <h2 className="empty-cart__title">{t("cart.emptyTitle") || "Your Cart is Empty"}</h2>
        <p className="empty-cart__lead">
          {t("cart.emptyLead") || "You haven't added any eSIM packages yet. Start exploring our plans to get connected!"}
        </p>
        <Link to={`/${lang}/shop`} className="empty-cart__cta">
          <MainButton type="button">{t("cart.browsePackages") || "Browse our eSIM Packages"}</MainButton>
        </Link>
      </section>
    </div>
  );
};

export default EmptyCartView;
